module.exports = __webpack_public_path__ + "img/KoenenRRResults.22baa3fb.png";